/**
 * The columns in the order the table displays them, keys the table has not
 * seeded yet last. Returns a new array: the caller's columns prop is shared
 * with the table, and sorting it in place would reorder the table itself.
 */
export function sortColumnsByDisplayOrder<T extends { key: string }>(
  columns: readonly T[],
  displayedColumns: readonly { key: string }[],
): T[] {
  const displayOrder = new Map(
    displayedColumns.map((column, index) => [column.key, index]),
  );
  return [...columns].sort(
    (a, b) =>
      (displayOrder.get(a.key) ?? Infinity) -
      (displayOrder.get(b.key) ?? Infinity),
  );
}
